<template>
<div class="zcy-menu">
  <div class="hd">
    <app-icon type="icongonggao"></app-icon>
    采购公告
  </div>
  <div class="bd">
    <a-menu
      @click="handleClick"
      style="width: 300px"
      :selectedKeys="selectedKeys"
      :openKeys="openKeys"
      mode="inline"
      @openChange="onOpenChange"
    >
      <a-sub-menu v-for="item in menus" :key="item.code">
        <span slot="title"><span>{{ item.title }}</span></span>
        <a-menu-item
          v-for="cur in item.children"
          :key="cur.code"
        >
          {{ cur.title }}
        </a-menu-item>
      </a-sub-menu>
    </a-menu>
  </div>
</div>
</template>

<script>
import data from '@/utils/menu.js';
import AppIcon from '@/components/icon';

function getFlattenData (data) {
  return data.reduce(function (total, cur) {
    return total.concat(cur.children);
  }, []);
};

function getItemByCode (code, arr) {
  for (let i = 0; i < arr.length; i++) {
    if (code === arr[i].code) {
      return arr[i];
    }
  }
  return null;
}

var d = getFlattenData(data);

export default {
  name: 'zcy-menu',
  components: {
    'app-icon': AppIcon
  },
  data () {
    return {
      menus: data
    };
  },
  props: {
    handleMenuClick: {
      type: Function,
      default: () => {}
    },
    selectedKeys: {
      type: Array,
      default: () => ['3001']
    },
    openKeys: {
      type: Array,
      default: () => ['a1']
    },
    handleOpenChange: {
      type: Function,
      default: () => {}
    }
  },
  methods: {
    handleClick (e) {
      const item = getItemByCode(e.key, d);
      this.handleMenuClick(e.key, item.title || '公告');
    },
    onOpenChange (openKeys) {
      this.handleOpenChange(openKeys);
    }
  }
};
</script>

<style lang="less">
.zcy-menu {
  width: 300px;
  .hd {
    height: 60px;
    padding: 20px;
    font-size: 16px;
    background: #fff;
    border-bottom: 1px solid #e9e9e9;
    line-height: 20px;
  }
  .bd {
    height: 867px;
    overflow-y: scroll;
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/menu.vue